import { Modal } from "react-bootstrap";
import ButtonLoader from "./ButtonLoader";

const EmailVerificationModal = ({
  isOpen,
  email,
  onClose,
  onResendEmail,
  isLoading = false,
}) => {
  return (
    <Modal
      show={isOpen}
      onHide={onClose}
      centered
      backdrop="static"
      keyboard={false}
    >
      {/* Header with close icon */}
      <Modal.Header closeButton style={{ border: "none" }} onClick={onClose} />

      <Modal.Body className="px-4 pb-4 text-center">
        {/* Icon */}
        <div className="mb-4 d-flex justify-content-center">
          <svg
            width="56"
            height="56"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#112314"
            strokeWidth="2"
            className="text-primary"
          >
            <path d="M4 4h16v16H4z" stroke="none" />
            <path d="M4 4l8 8 8-8" />
            <path d="M4 20l6-6" />
            <path d="M20 20l-6-6" />
          </svg>
        </div>

        {/* Title */}
        <h3
          style={{
            fontWeight: 600,
            color: "#111827",
            marginBottom: "0.75rem",
          }}
        >
          Verify Your Email
        </h3>

        {/* Description */}
        <p
          style={{
            fontSize: "0.95rem",
            color: "#6B7280",
            lineHeight: "1.6",
            marginBottom: "1rem",
          }}
        >
          We’ve sent a verification link to:
          <br />
          <strong style={{ color: "#111827" }}>{email}</strong>
        </p>

        <p
          style={{
            fontSize: "0.9rem",
            color: "#6B7280",
            marginBottom: "2rem",
          }}
        >
          Please verify your email address to continue.
        </p>

        {/* Button */}
        <button
          type="button"
          onClick={onResendEmail}
          disabled={isLoading}
          style={{
            width: "100%",
            padding: "12px 24px",
            borderRadius: "50px",
            border: "none",
            backgroundColor: "#112314",
            color: "#ffffff",
            fontWeight: 600,
            fontSize: "0.95rem",
          }}
        >
          {isLoading ? (
            <ButtonLoader color="#fff" />
          ) : (
            "Resend Verification Email"
          )}
        </button>
      </Modal.Body>
    </Modal>
  );
};

export default EmailVerificationModal;
